import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ko from './locales/ko.json'
import en from './locales/en.json'
import zhCN from './locales/zh-CN.json'
import zhTW from './locales/zh-TW.json'
import ja from './locales/ja.json'
import es from './locales/es.json'
import vi from './locales/vi.json'

export const LANGUAGE_STORAGE_KEY = 'pixgen-language'

export const SUPPORTED_LANGUAGES = [
  { code: 'ko', label: '한국어' },
  { code: 'en', label: 'English' },
  { code: 'zh-CN', label: '简体中文' },
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'ja', label: '日本語' },
  { code: 'es', label: 'Español' },
  { code: 'vi', label: 'Tiếng Việt' },
] as const

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code']

function getStoredLanguage(): LanguageCode {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY)
    if (stored && SUPPORTED_LANGUAGES.some((l) => l.code === stored)) {
      return stored as LanguageCode
    }
  } catch {
    // localStorage 접근 불가(프라이빗 모드 등) 시 기본값 사용
  }
  return 'ko'
}

i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: ko },
    en: { translation: en },
    'zh-CN': { translation: zhCN },
    'zh-TW': { translation: zhTW },
    ja: { translation: ja },
    es: { translation: es },
    vi: { translation: vi },
  },
  lng: getStoredLanguage(),
  fallbackLng: 'ko',
  load: 'currentOnly',
  // 'aspectRatios.21:9' 같은 키의 ':'가 네임스페이스 구분자로 해석되지 않도록 비활성화
  nsSeparator: false,
  interpolation: { escapeValue: false },
  returnEmptyString: false,
})

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
})
document.documentElement.lang = i18n.language

/**
 * 동적 키 번역 헬퍼. i18next.d.ts 의 키 타입 검사는 리터럴 키에만 적용되므로,
 * 런타임 문자열 키(errorCode, 파라미터 키 등)는 exists() 가드 후 캐스팅하여 조회한다.
 */
export function tDynamic(key: string, params?: Record<string, unknown>): string | undefined {
  if (!i18n.exists(key)) return undefined
  return (i18n.t as (k: string, o?: Record<string, unknown>) => string)(key, params)
}

export function setLanguage(lang: LanguageCode) {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang)
  } catch {
    // 저장 실패 시에도 세션 내 전환은 동작해야 한다
  }
  void i18n.changeLanguage(lang)
}

export default i18n
